import React from 'react'
import ProgressCircle from './progress-circle'

export const LoadingOverlay = () => (
  <div className='LoadingOverlay'>
    <div className='LoadingOverlay-content'>
      <div>Just a sec...</div>
      <div>your personalised card matches are almost ready!</div>
      <br />
      <ProgressCircle />
    </div>
  </div>
)
